import { useTranslation } from "react-i18next";
import { CircularProgress } from "@material-ui/core";

import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import { Typography, Button, TextField, DialogActions } from "@material-ui/core";

// Connectors
import backendConnector from "../../../services/connectors/backendConnector";

// Styles
import RenameAssessmentPopoverStyle from "../../../assets/styles/materialUI/questionnaire/assessmentResult/RenameAssessmentPopoverStyle";

// Providers
import { useLanguage } from "../../../contexts/languageContext";

export default function RenameAssessmentPopover({
	partialLoading,
	setPartialLoading,
	renameDialogOpen,
	renameSelectedItem,
	renameValue,
	setRenameDialogOpen,
	setRenameValue,
	setRenameSelectedItem,
	initiateResult,
	setError,
	setMessage,
	setHistoryResult,
}) {
	const { t } = useTranslation();
	const { direction } = useLanguage();
	const classes = RenameAssessmentPopoverStyle();

	const handleRename = async (item, name) => {
		setPartialLoading(true);
		let data = {
			id: item?.id,
			name: name,
		};
		let response = await backendConnector.updateQuestionnaire(data);
		if (response?.error) {
			setError(response?.error);
		} else if (response?.message) {
			setMessage(response?.message);
		} else {
			setError("common.errors.generic");
		}
		if (response?.historyResult) {
			setHistoryResult(response?.historyResult);
		}
		if (response?.error) {
			setError(t("assessment.results.historyInitError"));
		}
		await initiateResult(false);
		setPartialLoading(false);
	};

	return (
		<Dialog
			open={renameDialogOpen}
			onClose={() => {
				setRenameDialogOpen(false);
				setRenameValue("");
				setRenameSelectedItem(null);
			}}
			maxWidth="sm"
			fullWidth
			dir={direction}
		>
			<DialogTitle className={classes.DialogTitle}>{t("assessment.results.history.rename.title")}</DialogTitle>
			<DialogContent className={classes.DialogContent}>
				<Typography variant="body2" className={classes.DialogContent}>
					{t("assessment.results.history.rename.body", { date: renameSelectedItem?.date })}
				</Typography>
				<TextField
					label={t("assessment.results.history.rename.field")}
					fullWidth
					value={renameValue}
					onChange={(e) => setRenameValue(e.target.value)}
					variant="filled"
				/>
			</DialogContent>
			<DialogActions className={classes.actionButtonContainer}>
				<Button
					onClick={() => {
						setRenameDialogOpen(false);
						setRenameValue("");
						setRenameSelectedItem(null);
					}}
					variant="contained"
					color="primary"
					className={classes.cancelButton}
				>
					{t("common.buttons.cancel")}
				</Button>
				<Button
					onClick={async () => {
						await handleRename(renameSelectedItem, renameValue);
						setRenameDialogOpen(false);
						setRenameValue("");
						setRenameSelectedItem(null);
					}}
					variant="contained"
					color="primary"
					disabled={partialLoading || !renameValue || renameValue.trim() === ""}
					className={classes.renameButton}
				>
					{partialLoading ? (
						<CircularProgress size={18} className={classes.progressIcon} />
					) : (
						t("assessment.results.history.actions.rename")
					)}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
